import { render, staticRenderFns } from "./ValorantMatchCard.vue?vue&type=template&id=48f6556e&scoped=true"
import script from "./ValorantMatchCard.vue?vue&type=script&lang=js"
export * from "./ValorantMatchCard.vue?vue&type=script&lang=js"
import style0 from "./ValorantMatchCard.vue?vue&type=style&index=0&id=48f6556e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6556e",
  null
  
)

export default component.exports